<div class="speechText container mt-3">
   <span class="float-left" [hidden]="!speechService.supportSpeech()">
      <button class="operationSpeechButton" (click)="save()">
      <img class="operationSpeechImageButton" src="assets/speech/save.svg" alt="Save">
    </button>
    <button class="operationSpeechButton" (click)="copy()">
      <img class="operationSpeechImageButton" src="assets/speech/copy.svg" alt="Save">
    </button>
   </span>
  <span class="float-center" [hidden]="!speechService.supportSpeech()">
     <button (click)="start()" id="start_button">
        <img id="start_img" src="assets/speech/speech.webp" alt="Start"/>
      </button>
  </span>
  <span class="float-right" [hidden]="!speechService.supportSpeech()">
    <!-- Hidden -->
    <button class="operationSpeechButton" style="visibility: hidden">
      <img class="operationSpeechImageButton" src="assets/speech/clear.svg" alt="Save">
    </button>
    <button class="operationSpeechButton" (click)="speechService.clearText()">
      <img class="operationSpeechImageButton" src="assets/speech/clear.svg" alt="Save">
    </button>
  </span>
  <hr/>
  <div id="info"></div>
  <div id="results">
    <span id="final_span" class="final"></span>
    <span id="interim_span" class="interim"></span>
    <p>
  </div>
</div>
